/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import NumberFormat from '../../utils/NumberFormat';

function CustomTooltip({ payload, label, active }) {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`Tipo de Despesa: ${label}`}</p>
        <p className="desc">{`Valor: ${NumberFormat(payload[0].value)}`}</p>
      </div>
    );
  }

  return null;
}

function Example({ dados }) {
  const processedData = dados.map((item) => ({
    tipo_despesa: item.TipoDespesa.nome,
    valor: item.valor,
  }));

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <BarChart
          width={500}
          height={300}
          data={processedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="tipo_despesa"
            angle={-45}
            textAnchor="end"
            interval={0}
            height={70}
            tick={{ fontSize: 10 }}
          />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="valor" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

Example.propTypes = {
  dados: PropTypes.array.isRequired,
};

export default Example;
